import React from 'react';
import {FilterConfig, FilterOptions, ThConfig} from '../types';
import {useTranslation} from 'react-i18next';
import Select from "src/UI/Select/Select";
import {Option, OptionValue, SelectThemes} from "src/UI/Select/types";

interface IProps {
  item: FilterConfig;
  thConfig: ThConfig;
  filterOptions?: FilterOptions;
  onChange: (value: OptionValue) => void;
  propsValue: string;
}

const DefaultSelect = ({
  item,
  thConfig,
  filterOptions,
  onChange,
  propsValue,
}: IProps) => {
  const { t: tg } = useTranslation('translation');
  return (
    <Select
      theme={SelectThemes.FROM_TABLE}
      hasSearch={item.selectConfig?.hasSearch===undefined || item.selectConfig.hasSearch}
      onChange={onChange}
      propsValue={propsValue}
      disablePortal={false}
      options={
        [
          {
            title: tg('select-all'),
            value: null,
            isControllerHidden: true
          },
          ...( filterOptions?.[item.innerOptionsId || thConfig.columnId] as Option[] || [])
        ] as Option[]
      }
      {...item.selectConfig}
    />
  );
};

export default DefaultSelect;